import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageLoaderContainer } from "./styled";
import { Flex, FlexSpan, H3, Loader } from "../../ui";
export const PageLoader = ({ message }) => {
    return (_jsx(PageLoaderContainer, { children: _jsx(FlexSpan, { children: _jsxs(Flex, { column: true, alignItems: "center", gap: "1rem", children: [_jsx(FlexSpan, { children: _jsx(Loader, {}) }), message && (_jsx(FlexSpan, { children: _jsx(H3, { children: message }) }))] }) }) }));
};
